import { render, staticRenderFns } from "./Us.vue?vue&type=template&id=96ad8266"
import script from "./Us.vue?vue&type=script&lang=js"
export * from "./Us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports